// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SimpleIntakeAccountContactPhonesModel {
    'home'?: string;
    'mobile'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SimpleIntakeAccountContactPhonesModel>> = [
        {
            "name":     "home",
            "baseName": "home",
            "type":     "string"
        },
        {
            "name":     "mobile",
            "baseName": "mobile",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return SimpleIntakeAccountContactPhonesModel.attributeTypeMap;
    }
}
